import { memo } from 'react';

const style = {
  position: 'absolute',
  display: 'block',
  overflow: 'visible',
  zIndex: '10',
};

export const ChartSvg = memo(({ height, width, maxY, metric, data, color }) => {
  if (!width) return null;

  // margin sets the gap and the beginning and at the end
  // of the chart to cut the middle of a day column
  const margin = width / data.size / 2;
  const step = width / data.size;

  let coords = [];
  let countX = 0;

  data.forEach((value) => {
    const coord = {};
    coord.x = countX++;
    coord.y = maxY && value[metric] ? (height / maxY) * value[metric] : 0;
    coords.push(coord);
  });

  const xScale = (d) => d.x * step;
  const yScale = (d) => height - Math.round(d.y);

  let pathData = '';
  coords.forEach((data, i) => {
    pathData += `${i === 0 ? 'M' : 'L'} ${xScale(data)}, ${yScale(data)} `;
  });

  return (
    <svg
      width='100%'
      height={height}
      xmlns='http://www.w3.org/2000/svg'
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio='none'
      style={style}
    >
      <g style={{ transform: `translateX(${margin}px)` }}>
        <path
          d={pathData}
          fill='none'
          stroke={color}
          strokeWidth='2'
          strokeLinejoin='round'
          vectorEffect='non-scaling-stroke'
        />
      </g>
    </svg>
  );
});

ChartSvg.displayName = 'ChartSvg';
